import React, { useEffect, useMemo } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchDesignation } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";

const DesignationDropdown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  rowData,
  required,
}) => {
  const designationName = getValues().designation;
  const selectedDesignation = watch("desig_id");

  const {
    data: designations,
    isLoading,
    error,
  } = useQuery(["designations"], () => fetchDesignation(), {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });

  const options = useMemo(
    () =>
      designations?.data?.data?.map((designation) => ({
        value: designation.desig_id,
        label: designation.designation,
      })) || [],
    [designations]
  );

  useEffect(() => {
    if (rowData && options.length) {
      const selectedOption = options.find(
        (option) => option.value === rowData?.desig_id
      );
      setValue("desig_id", selectedOption?.value);
    }
  }, [rowData, options, setValue]);

  const selectedOption = options.find(
    (option) => option.value === selectedDesignation || designationName
  );

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading designations</div>;

  return (
    <Controller
      name="desig_id"
      control={control}
      rules={{
        required: required ? "Designation is required" : false,
        validate: (value) => {
          if (required && !value) return "Designation is required";
          return true;
        },
      }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          placeholder="Select Designation"
          value={selectedOption || null}
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            control: (base) => ({
              ...base,
              height: "42px",
            }),
            option: (base, { isFocused, isSelected }) => ({
              ...base,
            }),
          }}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption.value : "";
            field.onChange(value);
            setValue("desig_id", value);
          }}
          className={`react-select-container ${errors.desig_id ? "is-invalid" : ""
            }`}
        />
      )}
    />
  );
};

export default DesignationDropdown;
